import React, { useEffect, useState, useRef } from "react";
import "./CampoLuzes.css";
import { LightGroup } from "../Classes/LightGroup";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";
import { getLuzesStatusFlex35, statusDasLuzesFlex35 } from "../../API/FeedBackLuzes";

const GroupLightComponent = () => {
  const groupRefs = useRef({
    grupo08: React.createRef(),
    grupo09: React.createRef(),
    grupo10: React.createRef(),
    grupo11: React.createRef(),
    grupo12: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo08: false,
    grupo09: false,
    grupo10: false,
    grupo11: false,
    grupo12: false,

  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      setLoading(false);
      console.log("Status das luzes:", statusDasLuzesFlex35);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8300);
  
    return () => clearInterval(intervalId);
  }, []);


  const updateLightGroup = () => {
    setImageStates({
      grupo08: statusDasLuzesFlex35.includes("1H10") && !statusDasLuzesFlex35.includes("1H00"),
      grupo09: statusDasLuzesFlex35.includes("1I10") && !statusDasLuzesFlex35.includes("1I00"),
      grupo10: statusDasLuzesFlex35.includes("1J10") && !statusDasLuzesFlex35.includes("1J00"),
      grupo11: statusDasLuzesFlex35.includes("1K10") && !statusDasLuzesFlex35.includes("1K00"),
      grupo12: statusDasLuzesFlex35.includes("1L10") && !statusDasLuzesFlex35.includes("1L00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      <div className="group" id="campoGroup-pagina2">

        {/* Grupo 8 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo08}
          groupId="grupo08"
          descricao="Hall Entrada"
          imageUrl={imageStates.grupo08 ? Ligado : Desligado}
          onCommand="1H10"
          offCommand="1H00"
          x={28.4}
          y={58.6}
          width={1.75}
          height={3}
          imageState={imageStates.grupo08}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo08}
          groupId="grupo08"
          descricao="Hall Entrada"
          imageUrl={imageStates.grupo08 ? Ligado : Desligado}
          onCommand="1H10"
          offCommand="1H00"
          x={31.8}
          y={58.4}
          width={1.75}
          height={3}
          imageState={imageStates.grupo08}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 9 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo09}
          groupId="grupo09"
          descricao="Circulação"
          imageUrl={imageStates.grupo09 ? Ligado : Desligado}
          onCommand="1I10"
          offCommand="1I00"
          x={37.2}
          y={60}
          width={1.75}
          height={3}
          imageState={imageStates.grupo09}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 10 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo10}
          groupId="grupo10"
          descricao="Varanda Teen Louge"
          imageUrl={imageStates.grupo10 ? Ligado : Desligado}
          onCommand="1J10"
          offCommand="1J00"
          x={31.9}
          y={43.6}
          width={1.75}
          height={3}
          imageState={imageStates.grupo10}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 11 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo11}
          groupId="grupo11"
          descricao="Varanda Sport Bar"
          imageUrl={imageStates.grupo11 ? Ligado : Desligado}
          onCommand="1K10"
          offCommand="1K00"
          x={30.2}
          y={66.6}
          width={1.75}
          height={3}
          imageState={imageStates.grupo11}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 12 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo12}
          groupId="grupo12"
          descricao="Tomadas Sport Bar"
          imageUrl={imageStates.grupo12 ? Ligado : Desligado}
          onCommand="1L10"
          offCommand="1L00"
          x={37}
          y={68.2}
          width={1.75}
          height={3}
          imageState={imageStates.grupo12}
          onToggleLightGroup={handleToggleLightGroup}
        />
        
        {/* Legenda de acionamentos */}

        <div
          className="campoGroup-clickable-element"
          style={{ top: '76.4%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo08', !imageStates.grupo08); groupRefs.current.grupo08.current.sendCommand(groupRefs.current.grupo08.current.props.descricao, imageStates.grupo08 ? groupRefs.current.grupo08.current.props.offCommand : groupRefs.current.grupo08.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo08 ? 'Highlighted' : ''}`}>8</p>
          <p className="textBar">Hall Entrada</p>
        </div>
        <div
          className="campoGroup-clickable-element"
          style={{ top: '80.5%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo09', !imageStates.grupo09); groupRefs.current.grupo09.current.sendCommand(groupRefs.current.grupo09.current.props.descricao, imageStates.grupo09 ? groupRefs.current.grupo09.current.props.offCommand : groupRefs.current.grupo09.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo09 ? 'Highlighted' : ''}`}>9</p>
          <p className="textBar">Circulação</p>
        </div>
        <div
          className="campoGroup-clickable-element"
          style={{ top: '84.6%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo10', !imageStates.grupo10); groupRefs.current.grupo10.current.sendCommand(groupRefs.current.grupo10.current.props.descricao, imageStates.grupo10 ? groupRefs.current.grupo10.current.props.offCommand : groupRefs.current.grupo10.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo10 ? 'Highlighted' : ''}`}>10</p>
          <p className="textBar">Varanda Teen Louge</p>
        </div>
        <div
          className="campoGroup-clickable-element"
          style={{ top: '88.7%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo11', !imageStates.grupo11); groupRefs.current.grupo11.current.sendCommand(groupRefs.current.grupo11.current.props.descricao, imageStates.grupo11 ? groupRefs.current.grupo11.current.props.offCommand : groupRefs.current.grupo11.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo11 ? 'Highlighted' : ''}`}>11</p>
          <p className="textBar">Varanda Sport Bar</p>
        </div>
        <div
          className="campoGroup-clickable-element"
          style={{ top: '92.8%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo12', !imageStates.grupo12); groupRefs.current.grupo12.current.sendCommand(groupRefs.current.grupo12.current.props.descricao, imageStates.grupo12 ? groupRefs.current.grupo12.current.props.offCommand : groupRefs.current.grupo12.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo12 ? 'Highlighted' : ''}`}>12</p>
          <p className="textBar">Tomadas Sport Bar</p>
        </div>
      </div>
    </>
  );
};

export default React.memo(GroupLightComponent);